/**
 * Admin navigation utilities for 2FA flow
 * Extracts admin routing logic into testable functions
 */

/**
 * Determine navigation path based on admin role
 * Returns the appropriate dashboard path or null if role is invalid
 */
export const getAdminNavigationPath = (role: string): string | null => {
  switch (role) {
    case "product-manager":
      return "/pm-dashboard/overview";
    case "operation-and-risk":
      return "/org-list";
    case "sales-support":
      return "/sales-support/new";
    default:
      return null;
  }
};

/**
 * Check if admin role is valid
 */
export const isValidAdminRole = (role: string): boolean => {
  return getAdminNavigationPath(role) !== null;
};
